import { useMutation, useQueryClient } from '@tanstack/react-query';
import { completeOffboard } from '../api/userManagementApi';
import { userKeys } from './userKeys';

export const useCompleteOffboard = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userId: string) => completeOffboard(userId),

    onSuccess: (_, userId) => {
      queryClient.invalidateQueries({
        queryKey: userKeys.detail(userId),
      });
      queryClient.invalidateQueries({ queryKey: userKeys.lists() });
    },
  });
};
